import LOGO from "../images/UTPaquime.png";

export const Team__UTPaquime = {
  name: "UT Paquime",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#007A6D",
  teamJerseyColor: "#0F172A",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 34 + 43 + 33,
  goalsScoredAgainst: 42 + 41 + 32,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
